import { useState } from 'react'

/**
 * Hook personnalisé pour gérer l'état d'une modal
 */
export const useModal = () => {
  const [isModalVisible, setIsModalVisible] = useState(false)

  const showModal = () => setIsModalVisible(true)
  const closeModal = () => setIsModalVisible(false)

  return {
    isModalVisible,
    showModal,
    closeModal
  }
}
